import { SpaceVertical } from '@looker/components';
import { BIToggleButton } from '@pulsepointinc/bi-components';
import { type FC, useEffect, useState } from 'react';
import { useFilters } from '../../../../../../../hooks/useFilters';
import type { Filter } from '../../../../../../../stores/filters';
import useFilterSuggestions from '../../../../hooks/useFilterSuggestions';

interface PrescribingBehaviorChangeProps {
  onChange: (filter: Filter) => void;
}

const filterId = 'prescribing_behavior_change_filter';

const PrescribingBehaviorChange: FC<PrescribingBehaviorChangeProps> = ({ onChange }) => {
  const { filters } = useFilters();
  const expression = filters?.[filterId]?.expression;
  const { suggestions = [], defaultFilterValue } = useFilterSuggestions(filterId);

  const toggleOptions = suggestions;

  const defaultFilter: Filter = {
    filterName: filterId,
    expression: defaultFilterValue,
    enabled: true,
    expressionType: 'target',
  };

  const [initialToggleValue, setInitialToggleValue] = useState(expression || defaultFilterValue);

  useEffect(() => {
    if (expression) {
      setInitialToggleValue(expression);
    } else if (onChange && !expression && defaultFilterValue) {
      onChange(defaultFilter);
    }
  }, []);

  const handleToggleChange = (toggleValue: string | null) => {
    if (toggleValue === null) return;
    const filter: Filter = {
      filterName: filterId,
      expression: toggleValue,
      enabled: true,
      expressionType: 'target',
    };
    onChange(filter);
  };

  return (
    <SpaceVertical gap="u2" paddingX="u6" paddingY="u1">
      <BIToggleButton
        width="100%"
        toggleValues={toggleOptions}
        initialValue={initialToggleValue}
        tooltips={{
          dropper: '10% less than previous period',
          influenced: '10% more than previous period',
          stable: 'within 10% of previous period',
          'new prescriber': 'Prescribing more than the previous period when previous period was 0',
        }}
        onToggleChange={handleToggleChange}
      />
    </SpaceVertical>
  );
};

export default PrescribingBehaviorChange;
